export function selectRandomElements(type, number, inputArray) {
  if (number <= 0) {
    return [];
  }

  // Determine which filter to apply based on the type
  let filteredArray;
  if (type === 'models') {
    filteredArray = inputArray.filter(item => item.resources && item.resources.data && item.resources.data.length >= 4);
  } else if (type === 'categories') {
    filteredArray = inputArray.filter(item => item.resources && item.resources.data && item.resources.data.length >= 4);
  } else {
    // Return an empty array if an unknown type is passed
    return [];
  }

  if (number >= filteredArray.length) {
    return filteredArray.slice();
  }

  const result = [];
  const arrayCopy = filteredArray.slice();
  
  while (result.length < number) {
    const randomIndex = Math.floor(Math.random() * arrayCopy.length);
    const randomElement = arrayCopy.splice(randomIndex, 1)[0];
    result.push(randomElement);
  }

  return result;
}
